import { baseDevEnvironment } from './environment.base-dev';

export const environment = {
  ...baseDevEnvironment,
  apiBaseUrl: 'https://api-dev.gen.com.br/graphql',
  appDomain: 'https://checkout-dev.gen.com.br',
};
